import { scheduleMixpanelLoad } from "@/services/mix-panel/mix-panel-lazy";
// import { initZendeskDraggable } from "@/utils/zendesk-util";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./services/mix-panel/mix-panel-util.ts";
import "./styles/ecare-design-system.css";

/** to make it draggable script is override */
// initZendeskDraggable();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

scheduleMixpanelLoad();
